import React from 'react';
import {
	styled,
	ParentBoundComponent
} from 'ps-gui';

import ActivationModel from './activationmodel';
import { withGlobalContext } from '../../data/globalcontext';

import PasswordForm from './components/passwordform';
import Result from './components/result';

class ActivationModule extends ParentBoundComponent {
	constructor() {
		super();
		this.setPassword = this.setPassword.bind(this);
		this.setProperty = this.setProperty.bind(this);
		this.showLoginForm = this.showLoginForm.bind(this);
	}

	getModel() {
		return new ActivationModel(this.getData());
	}

	setModel(model) {
		this.setData(model ? model.getData() : null);
	}

	async setPassword() {
		this.setModel(await this.getModel().setPassword());
	}

	showLoginForm() {
		const url = window.location.href.split('?')[0] + '?li=1';
		window.location = url;
	}

	render() {
		const model = this.getModel();

		return <Wrapper>
			{model.isResult() ?
				<Result data={model.getResult()} showLoginForm={this.showLoginForm} /> :
				<PasswordForm data={model.getData()} setPassword={this.setPassword} setProperty={this.setProperty} />}
		</Wrapper>;
	}
}

const Wrapper = styled.div`
	${props => props.theme.pageContentPadding}

	.ps-form {
		width: 370px;

		.ps-formItem {
			margin-bottom: 24px;
		}
	}

	.footer {
		border-top: 1px solid ${props => props.theme.pageSeparatorColor};
		padding-top: 24px;
		margin-top: 24px;

		.text {
			color: ${props => props.theme.disabledTextColor};
			font-weight: 400;
			font-size: 16px;
			margin-right: 24px;
		}
	}
`;

export default withGlobalContext(ActivationModule);
